import React from 'react';
import _epCarousel from "./enginParts/_epCarousel";
import _epBanner from "./enginParts/_epBanner";
import _epText from "./enginParts/_epText";

const HomeEngine = ({ items }) => {
    if (!items || !Array.isArray(items)) return null;

    return (
        <>
            {items.map((i, index) => {
                const itemKey = i.Id != null ? i.Id : `engine-item-${index}`;
                switch (i.Type) {
                    case "CAROUSEL":
                        return <_epCarousel key={itemKey} carousel={i} />;
                    case "BANNER":
                        return <_epBanner key={itemKey} banner={i} isFirstHomeSection={index === 0} />;
                    case "TEXT":
                        return <_epText key={itemKey} item={i} />;
                    default:
                        return null;
                }
            })}
        </>
    );
};

export default React.memo(HomeEngine);
